<template lang="pug">
#mapa-leaflet(:style='{ height: height }', style='position: relative')
    div(:id='idMapa', :style='{ height: height }')
</template>

<script>
import { DEFAULT_CONFIG, TILE_LAYER_CONFIG } from '@/utils/mapa/mapa.config';
import L from 'leaflet';
import 'leaflet-easybutton';
import 'leaflet/dist/leaflet.css';
import 'leaflet-easybutton/src/easy-button.css';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.js';
import '@/utils/mapa/leaflet-zoominfo/L.Control.Zoominfo.css';
export default {
    name: 'MapaAlertasSocioambientais',
    props: {
        height: {
            required: false,
            type: String,
            default: '100%'
        },

        mapConfig: {
            required: false,
            type: Object
        },

        mapLayersConfigs: {
            required: false,
            type: Array
        },

        idMapa: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            mapa: null,
            config: {},

            featureGroup: null,
            mapLayers: null,
            camadas: []
        };
    },

    watch: {
        mapLayersConfigs: {
            handler(val) {
                if (this.mapLayersConfigs) this.clearLayers();

                this.addMapLayers();
            }
        },

        mapConfig: function () {
            this.addMapControls();
        }
    },

    mounted() {
        this.config = Object.assign(DEFAULT_CONFIG, this.mapConfig);

        if (!this.mapa) {
            this.createMap();
        }
    },
    methods: {
        createMap() {
            L.Map.include({
                _initControlPos: function () {
                    const corners = (this._controlCorners = {});
                    const container = (this._controlContainer =
                        L.DomUtil.create(
                            'div',
                            'leaflet-control-container',
                            this._container
                        ));

                    function createCorner(vSide, hSide) {
                        const className = `leaflet-${vSide} leaflet-${hSide}`;

                        corners[vSide + hSide] = L.DomUtil.create(
                            'div',
                            className,
                            container
                        );
                    }

                    L.DomEvent.disableClickPropagation(container);
                    L.DomEvent.disableScrollPropagation(container);

                    createCorner('top', 'left');
                    createCorner('top', 'right');
                    createCorner('bottom', 'left');
                    createCorner('bottom', 'right');
                    createCorner('top', 'center');
                    createCorner('middle', 'center');
                    createCorner('middle', 'left');
                    createCorner('middle', 'right');
                    createCorner('bottom', 'center');
                }
            });

            this.mapa = L.map(this.idMapa, {
                ...this.config,
                maxZoom: 17
            });

            this.featureGroup = L.markerClusterGroup();

            this.featureGroup.addTo(this.mapa);

            L.tileLayer(TILE_LAYER_CONFIG.url, {
                attribution: TILE_LAYER_CONFIG.attribution
            }).addTo(this.mapa);

            if (!_.isEmpty(this.mapLayersConfigs)) {
                this.addMapLayers();
                this.addMapControls();
            }
        },
        addMapLayers() {
            if (!this.featureGroup) this.featureGroup = L.markerClusterGroup();

            this.mapLayers = {};

            this.mapLayersConfigs.forEach(layerConfig => {
                if (!layerConfig.geoJson) {
                    return;
                }

                let geometry = null;

                if (layerConfig.geoJson.type === 'Point') {
                    geometry = this.addPointLayer(layerConfig);
                    if (layerConfig.name) {
                        this.camadas[layerConfig.name] = geometry;
                    }
                } else {
                    geometry = L.geoJSON(
                        layerConfig.geoJson,
                        layerConfig.style
                    );

                    if (layerConfig.tooltip) {
                        geometry.bindTooltip(layerConfig.tooltip);
                    }

                    if (layerConfig.name) {
                        this.camadas[layerConfig.name] = geometry;
                    }
                }

                this.featureGroup.addLayer(geometry);
            });

            if (!this.mapa.hasLayer(this.featureGroup)) {
                this.featureGroup.addTo(this.mapa);
            }

            this.centralize();
        },
        addMapControls() {
            this.zoomControl();
            this.centralizeControl();
        },
        zoomControl() {
            L.control
                .zoom({
                    position: 'topright',
                    zoomControl: false
                })
                .addTo(this.mapa);
        },
        centralizeControl() {
            L.easyButton({
                position: 'topright',
                leafletClasses: true,
                states: [
                    {
                        stateName: 'center',
                        onClick: () => this.centralize(),
                        title: 'Centralizar',
                        icon: 'mdi mdi-crosshairs-gps'
                    }
                ]
            }).addTo(this.mapa);
        },
        centralize() {
            if (
                (this.mapLayersConfigs && this.mapLayersConfigs.length > 0) ||
                (this.mapLayers && !_.isEmpty(this.mapLayers))
            ) {
                if (this.mapLayersConfigs && this.mapLayersConfigs.length > 0) {
                    this.mapa.fitBounds(this.featureGroup.getBounds(), {
                        maxZoom: 17
                    });
                } else {
                    this.mapa.fitBounds(this.featureGroup.getBounds(), {
                        maxZoom: 5
                    });
                }
            } else {
                if (this.mapa) {
                    this.mapa.setView(
                        DEFAULT_CONFIG.center,
                        DEFAULT_CONFIG.zoom
                    );
                }
            }
        },
        clearLayers() {
            this.mapa.removeLayer(this.featureGroup);
            this.featureGroup = null;
        }
    }
};
</script>

<style></style>
